module.exports = "<img src=" + require("../../../../../assets/sitios/motoselpaisa/img/buscar-repuesto.jpg") + " class=img-responsive> ";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/pdf-viewer/templates/pdf-viewer-base.view.html
 ** module id = 879
 ** module chunks = 7
 **/